import { toast } from 'react-toastify';
import { axiosInstance } from '../../repository/Repository';
import {
    ADD_PAYMENT_ERROR,
    ADD_PAYMENT_START,
    ADD_PAYMENT_SUCCESS,
    REFERRAL_ID,
    SET_PAYMENT_METHOD_DELETE_ERROR,
    SET_PAYMENT_METHOD_DELETE_LOADING,
    SET_PAYMENT_METHOD_DELETE_SUCCESS,
    SET_PAYMENT_METHOD_ERROR,
    SET_PAYMENT_METHOD_LOADING,
    SET_PAYMENT_METHOD_ROLE_ERROR,
    SET_PAYMENT_METHOD_ROLE_LOADING,
    SET_PAYMENT_METHOD_ROLE_SUCCESS,
    UPDATE_CUSTOMER_ERROR,
    UPDATE_CUSTOMER_PENDING,
    UPDATE_CUSTOMER_SUCCESS,
} from './types';

export const setUser = (userData) => ({
    type: 'SET_USER',
    payload: userData,
});

export const setSearchData = (searchData) => ({
    type: 'SET_SEARCH_DATA',
    payload: searchData,
});

export const handleTempData = (data) => ({
    type: 'TEMP_DATA',
    payload: data,
});

export const saveReferralId = (id) => ({
    type: REFERRAL_ID,
    payload: id,
});

export const getCustomerDetails = () => async (dispatch, getState) => {
    try {
        const response = await axiosInstance.get('/user/customer');
        const previousUser = getState()?.user?.userData || {};
        const userDetails = response?.data?.user || response?.data;
        dispatch(
            setUser({
                ...previousUser,
                ...userDetails,
                role: previousUser?.role || userDetails?.role,
            })
        );
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const updateCustomerPersonalInfo =
    (id, data, message, onSuccess = () => { }) =>
        async (dispatch) => {
            dispatch({ type: UPDATE_CUSTOMER_PENDING });
            try {
                await axiosInstance.put(`/user/update/${id}`, data);
                await dispatch(getCustomerDetails());
                dispatch({ type: UPDATE_CUSTOMER_SUCCESS });
                toast.success(message);
                onSuccess();
            } catch (error) {
                dispatch({ type: UPDATE_CUSTOMER_ERROR });
                throw error;
            }
        };

export const addPaymentMethod =
    (data, onSuccess = () => { }, onError = () => { }) =>
        async (dispatch) => {
            dispatch({ type: ADD_PAYMENT_START });
            try {
                await axiosInstance.post(`/user-payment/add`, data);
                await dispatch(getCustomerDetails());
                dispatch({ type: ADD_PAYMENT_SUCCESS });
                toast.success('Card details added successfully');
                onSuccess();
            } catch (error) {
                console.log(error);
                toast.error(
                    error?.data?.message ||
                    'There was an error, Please try again later!'
                );
                onError();
                dispatch({ type: ADD_PAYMENT_ERROR });
                throw error;
            }
        };

export const deletePaymentMethod =
    (id, onSuccess = () => { }) =>
        async (dispatch) => {
            dispatch({
                type: SET_PAYMENT_METHOD_DELETE_LOADING,
                payload: { cardId: id },
            });
            try {
                await axiosInstance.delete(`/user-payment/delete/${id}`);
                await dispatch(getCustomerDetails());
                dispatch({ type: SET_PAYMENT_METHOD_DELETE_SUCCESS });
                toast.success('Card details deleted successfully');
                onSuccess();
            } catch (error) {
                toast.error(error?.data?.message);
                dispatch({ type: SET_PAYMENT_METHOD_DELETE_ERROR });
                throw error;
            }
        };

export const setPrimaryOrBackupPaymentMethod =
    (cardId, type, onSuccess = () => { }) =>
        async (dispatch) => {
            dispatch({
                type: SET_PAYMENT_METHOD_ROLE_LOADING,
                payload: { cardId, type },
            });
            try {
                await axiosInstance.post('/user-payment/set-primary-backup', {
                    cardId,
                    type,
                    isBackup: type === 'backup',
                    isPrimary: type === 'primary',
                });
                await dispatch(getCustomerDetails());
                dispatch({ type: SET_PAYMENT_METHOD_ROLE_SUCCESS });
                toast.success(`Card set as ${type} successfully`);
                onSuccess();
            } catch (error) {
                toast.error(
                    error?.data?.message ||
                    'There was an error, Please try again later!'
                );
                dispatch({ type: SET_PAYMENT_METHOD_ROLE_ERROR });
                throw error;
            }
        };

export const updateUserStatus =
    (status, onSuccess = () => { }) =>
        async (dispatch) => {
            dispatch({ type: ADD_PAYMENT_START });
            try {
                const response = await axiosInstance.put(`/user/customer/status`, {
                    status,
                });
                await dispatch(getCustomerDetails());
                dispatch({ type: ADD_PAYMENT_SUCCESS });
                toast.success(response.data?.message);
                onSuccess();
            } catch (error) {
                toast.error(error?.data?.message);
                dispatch({ type: ADD_PAYMENT_ERROR });
                throw error;
            }
        };
